import { setCookie } from './util'
export function clearCookie() {
    setCookie('getCmpyinfoByReqdomain', '')
    setCookie('logoimgurl', '');
    setCookie('allreqdomain', '');
    setCookie('cmpycode', '');
    setCookie('username', '')
    setCookie('nickname', '')
    setCookie('battention', '');
    setCookie('openid', '');
    setCookie('memberid', '')
    setCookie('mlevelcode', '')
    setCookie('mlevelname', '')
    setCookie('membercode', '')
    setCookie('mdiscount', '')
    setCookie('imore', '')
    setCookie('freticketnum', '')
    setCookie('openshare', '')
    setCookie('sex', '')
    setCookie('mphone', '')
    setCookie('email', '')
    setCookie('cbalance', '')
    setCookie('hpurl', '')
    setCookie('birthday', '')
    setCookie('ibalance', '')
    setCookie('emailcheck', '')
    setCookie('mphonecheck', '')
}


// WEBPACK FOOTER //
// ./src/util/celecookie.js